import { useEffect, useState } from "react";
import { navLinks } from "@/mocks/siteData";
import { useScrollSpy } from "@/hooks/useScrollSpy";

const navIds = navLinks.map((item) => item.id);

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const activeId = useScrollSpy(navIds);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const handleJump = (id: string) => {
    setMenuOpen(false);
    const el = document.getElementById(id);
    if (el) {
      el.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? "bg-background-50/90 backdrop-blur-md border-b border-background-200/70"
          : "bg-transparent"
      }`}
    >
      <nav className="w-full px-4 md:px-6 h-16 md:h-[68px] flex items-center justify-between">
        <button
          type="button"
          onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
          className="flex items-center gap-2 cursor-pointer"
        >
          <span className="w-9 h-9 flex items-center justify-center rounded-lg bg-primary-500 text-background-50">
            <i className="ri-play-circle-fill text-xl" />
          </span>
          <span className="font-heading font-bold text-lg text-foreground-950">
            蓝莓视频
          </span>
        </button>

        <div className="hidden md:flex items-center gap-1">
          {navLinks.map((item) => (
            <button
              key={item.id}
              type="button"
              onClick={() => handleJump(item.id)}
              className={`px-3 py-2 rounded-md text-sm font-label cursor-pointer transition-colors whitespace-nowrap ${
                activeId === item.id
                  ? "text-primary-700 bg-primary-100"
                  : "text-foreground-600 hover:text-foreground-950 hover:bg-background-100"
              }`}
            >
              {item.label}
            </button>
          ))}
        </div>

        <div className="hidden md:block">
          <button
            type="button"
            onClick={() => handleJump("access")}
            className="px-4 py-2 rounded-md bg-primary-500 text-background-50 text-sm font-label font-medium hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
          >
            查看访问指南
          </button>
        </div>

        <button
          type="button"
          onClick={() => setMenuOpen((v) => !v)}
          className="md:hidden w-10 h-10 flex items-center justify-center rounded-md text-foreground-800 cursor-pointer"
          aria-label="打开导航菜单"
          aria-expanded={menuOpen}
        >
          <i className={menuOpen ? "ri-close-line text-2xl" : "ri-menu-line text-2xl"} />
        </button>
      </nav>

      {menuOpen && (
        <div className="md:hidden bg-background-50/98 backdrop-blur-md border-b border-background-200/70 px-4 pb-4">
          <div className="flex flex-col gap-1 pt-2">
            {navLinks.map((item) => (
              <button
                key={item.id}
                type="button"
                onClick={() => handleJump(item.id)}
                className={`text-left px-3 py-2.5 rounded-md text-sm font-label cursor-pointer ${
                  activeId === item.id
                    ? "text-primary-700 bg-primary-100"
                    : "text-foreground-700 hover:bg-background-100"
                }`}
              >
                {item.label}
              </button>
            ))}
            <button
              type="button"
              onClick={() => handleJump("access")}
              className="mt-2 px-4 py-2.5 rounded-md bg-primary-500 text-background-50 text-sm font-label font-medium cursor-pointer"
            >
              查看访问指南
            </button>
          </div>
        </div>
      )}
    </header>
  );
}